@if (offersMap) {
  <div>
    <div *ngFor="let travel of travelSolution.travellers index as i" class="traveller">
      @if (!selectedCustomizedOffers[travel.xmlId]) {
        <div class="text-center" style="color:red">
          Nessun servizio disponibile
        </div>
      }
      @if (selectedCustomizedOffers[travel.xmlId]) {
        <h2>Passeggero {{i + 1}}</h2>
        <span>{{travel.type == 'ADULT' ? 'Adulto' : 'Ragazzo'}}</span>
        <div class="row flex-row flex-gap-8" >
          <mat-form-field class="flex">
            <mat-label>Servizio</mat-label>
            <mat-select [value]="selectedCustomizedOffers[travel.xmlId].catalogServiceId"
              (selectionChange)="changeService($event,travel.xmlId)">
              @for (serv of services[travel.xmlId]; track serv) {
                <mat-option [value]="serv.id">
                  {{serv.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex">
            <mat-label>Offerta</mat-label>
            <mat-select [value]="selectedCustomizedOffers[travel.xmlId].offerId"
              (selectionChange)="changeOffer($event,travel.xmlId)">
              @for (off of offers[travel.xmlId]; track off) {
                <mat-option [value]="off.id">
                  {{off.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (errors && errors[travel.xmlId]) {
          <div class="alert-error">
            @for ( mess of errors[travel.xmlId].messages; track  mess; let last = $last) {
              <div>
                @if (mess.length) {
                  <span><mat-icon>error</mat-icon>{{mess}} @if (!last) {
                  <span> - </span>
                }</span>
              }
            </div>
          }
        </div>
      }
      @if (selectedCustomizedOffers[travel.xmlId] && selectedCustomizedOffers[travel.xmlId].offerData) {
        <div class="price">
          <span class="price"
                        matTooltip="{{selectedCustomizedOffers[travel.xmlId].fee>0?'Prezzo:'+
                        (selectedCustomizedOffers[travel.xmlId].netPrice| currency:'EUR':'symbol':'1.2-2')
                        +' Diritti agenzia'+ (selectedCustomizedOffers[travel.xmlId].fee| currency:'EUR':'symbol':'1.2-2'):''}}">
            € {{selectedCustomizedOffers[travel.xmlId].price}}
          </span>
        </div>
        @if (selectedCustomizedOffers[travel.xmlId].offerData.description) {
          <div class="row" class="description"
            >
            <h2>{{selectedCustomizedOffers[travel.xmlId].offerData.display_name}}</h2>
            <span>{{selectedCustomizedOffers[travel.xmlId].offerData.description}}</span>
          </div>
        }
        <div class="row">
          <span>
            @if (selectedCustomizedOffers[travel.xmlId].offerData.can_change) {
              <span>
                <mat-icon color="primary">check_circle</mat-icon>
              </span>
            }
            @if (!selectedCustomizedOffers[travel.xmlId].offerData.can_change) {
              <span>
                <mat-icon color="warn">remove_circle</mat-icon>
              </span>
            }
            Cambio
          </span>
          <span>
            @if (selectedCustomizedOffers[travel.xmlId].offerData.can_refund) {
              <span>
                <mat-icon color="primary">check_circle</mat-icon>
              </span>
            }
            @if (!selectedCustomizedOffers[travel.xmlId].offerData.can_refund) {
              <span>
                <mat-icon color="warn">remove_circle</mat-icon>
              </span>
            }
            Rimborso
          </span>
        </div>
        @if (selectedCustomizedOffers[travel.xmlId].parameters) {
        }
        @for (offerParameter of selectedCustomizedOffers[travel.xmlId].parameters; track offerParameter; let offerParamIndex = $index) {
          <div class="row">
            <mat-form-field appearance="fill" class="fx-flex">
              <mat-label>{{offerParameter.name}}</mat-label>
              <mat-select [(ngModel)]="selectedCustomizedOffers[travel.xmlId].parameters[offerParamIndex].value" (selectionChange)="sendSelection()">
                @for (paramValue of offerParameter.values; track paramValue; let i = $index) {
                  <mat-option [value]="paramValue">
                    {{paramValue}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (selectedCustomizedOffers[travel.xmlId].cartaFrecciaRequired) {
          <div class="row fx-row fx-wrap" style="gap: 8px">
            <mat-form-field appearance="outline">
              <mat-label><span>CartaFRECCIA</span></mat-label>
              <input matInput placeholder="CartaFRECCIA" autocomplete="off"
                type='text' [(ngModel)]="travel.cartaFreccia" maxlength="30" required>
              <mat-hint>Obbligatoria</mat-hint>
            </mat-form-field>
          </div>
        }
      }
    }
  </div>
</div>
}

